import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import { toNumber } from 'lodash';
import { GChart } from 'vue-google-charts';
import { useGetFundQuery, useGetFundReportQuery, useUpdateAssetAllocationTargetsMutation } from '~/types/types';
import { editablePrecontractualReportAdditionalInfo } from '~/assets/fund/precontractualReport';
import { getLocale } from '~/functions/translate';
import { renderMarkdown } from '~/functions/markdown';
export default /*#__PURE__*/_defineComponent({
  __name: 'FossilOrNuclearTargets',
  setup: function setup(__props) {
    var route = useRoute();
    var locale = computed(function () {
      return getLocale();
    });
    var _useGetFundQuery = useGetFundQuery({
        id: toNumber(route.params.fund)
      }),
      fundResult = _useGetFundQuery.result;
    var fund = computed(function () {
      var _fundResult$value;
      return (_fundResult$value = fundResult.value) === null || _fundResult$value === void 0 ? void 0 : _fundResult$value.getFund;
    });
    var _useGetFundReportQuer = useGetFundReportQuery(computed(function () {
        return {
          input: {
            id: toNumber(route.params.fund),
            referencePeriodId: toNumber(route.query.referencePeriodId)
          }
        };
      }), computed(function () {
        var _route$query;
        return {
          enabled: !!((_route$query = route.query) !== null && _route$query !== void 0 && _route$query.referencePeriodId) && !!route.params.fund
        };
      })),
      calculatedSfdrReportResult = _useGetFundReportQuer.result,
      refetchFundReport = _useGetFundReportQuer.refetch;
    var calculatedSfdrReport = computed(function () {
      var _calculatedSfdrReport;
      return ((_calculatedSfdrReport = calculatedSfdrReportResult.value) === null || _calculatedSfdrReport === void 0 ? void 0 : _calculatedSfdrReport.getFundReport) || {
        nameOfFinancialMarketParticipant: '',
        legalEntityIdentifier: ''
      };
    });
    var _useUpdateAssetAlloca = useUpdateAssetAllocationTargetsMutation(),
      updateAssetAllocationTargets = _useUpdateAssetAlloca.mutate;
    var triggerUpdateAssetAllocationTargets = function triggerUpdateAssetAllocationTargets(key, val) {
      var _fund$value;
      var value = parseFloat(val);
      var input = {
        id: (_fund$value = fund.value) === null || _fund$value === void 0 ? void 0 : _fund$value.id,
        assetAllocationTargets: _defineProperty({}, key, isNaN(value) ? null : value)
      };
      updateAssetAllocationTargets({
        input: input
      }).then(function () {
        return refetchFundReport();
      });
    };
    var taxonomyAligned = computed(function () {
      var _fund$value2, _fund$value2$assetAll;
      return (_fund$value2 = fund.value) === null || _fund$value2 === void 0 ? void 0 : (_fund$value2$assetAll = _fund$value2.assetAllocationTargets) === null || _fund$value2$assetAll === void 0 ? void 0 : _fund$value2$assetAll.percentEnvironmentalTaxonomyAligned;
    });
    var taxonomyAlignedFossil = computed(function () {
      var _fund$value3, _fund$value3$assetAll;
      return (_fund$value3 = fund.value) === null || _fund$value3 === void 0 ? void 0 : (_fund$value3$assetAll = _fund$value3.assetAllocationTargets) === null || _fund$value3$assetAll === void 0 ? void 0 : _fund$value3$assetAll.percentTaxonomyAlignedFossil;
    });
    var taxonomyAlignedNuclear = computed(function () {
      var _fund$value4, _fund$value4$assetAll;
      return (_fund$value4 = fund.value) === null || _fund$value4 === void 0 ? void 0 : (_fund$value4$assetAll = _fund$value4.assetAllocationTargets) === null || _fund$value4$assetAll === void 0 ? void 0 : _fund$value4$assetAll.percentTaxonomyAlignedNuclear;
    });
    var taxonomyAlignedNoFossilNoNuclear = computed(function () {
      var _taxonomyAligned$valu, _taxonomyAlignedFossi, _taxonomyAlignedNucle;
      var aligned = (_taxonomyAligned$valu = taxonomyAligned.value) !== null && _taxonomyAligned$valu !== void 0 ? _taxonomyAligned$valu : 0; // Ensure a number
      var fossil = (_taxonomyAlignedFossi = taxonomyAlignedFossil.value) !== null && _taxonomyAlignedFossi !== void 0 ? _taxonomyAlignedFossi : 0;
      var nuclear = (_taxonomyAlignedNucle = taxonomyAlignedNuclear.value) !== null && _taxonomyAlignedNucle !== void 0 ? _taxonomyAlignedNucle : 0;
      return Math.max(0, aligned - fossil - nuclear); // Prevent negative values
    });
    var taxonomyAlignedEnabling = computed(function () {
      var _fund$value5, _fund$value5$assetAll;
      return (_fund$value5 = fund.value) === null || _fund$value5 === void 0 ? void 0 : (_fund$value5$assetAll = _fund$value5.assetAllocationTargets) === null || _fund$value5$assetAll === void 0 ? void 0 : _fund$value5$assetAll.percentTaxonomyAlignedEnabling;
    });
    var taxonomyAlignedTransitional = computed(function () {
      var _fund$value6, _fund$value6$assetAll;
      return (_fund$value6 = fund.value) === null || _fund$value6 === void 0 ? void 0 : (_fund$value6$assetAll = _fund$value6.assetAllocationTargets) === null || _fund$value6$assetAll === void 0 ? void 0 : _fund$value6$assetAll.percentTaxonomyAlignedTransitional;
    });
    var otherInvestments = computed(function () {
      var _taxonomyAligned$valu2;
      var aligned = (_taxonomyAligned$valu2 = taxonomyAligned.value) !== null && _taxonomyAligned$valu2 !== void 0 ? _taxonomyAligned$valu2 : 0;
      return Math.max(0, 100 - aligned);
    });
    var doesNotSumTo100 = computed(function () {
      var _taxonomyAligned$valu3, _taxonomyAlignedFossi2, _taxonomyAlignedNucle2;
      return ((_taxonomyAligned$valu3 = taxonomyAligned.value) !== null && _taxonomyAligned$valu3 !== void 0 ? _taxonomyAligned$valu3 : 0) + ((_taxonomyAlignedFossi2 = taxonomyAlignedFossil.value) !== null && _taxonomyAlignedFossi2 !== void 0 ? _taxonomyAlignedFossi2 : 0) + ((_taxonomyAlignedNucle2 = taxonomyAlignedNuclear.value) !== null && _taxonomyAlignedNucle2 !== void 0 ? _taxonomyAlignedNucle2 : 0) + otherInvestments.value !== 100;
    });
    var getPieChartData = computed(function () {
      var rawData = [['Investment Type', 'Amount'], ['Fossil', taxonomyAlignedFossil.value], ['Nuclear', taxonomyAlignedNuclear.value], ['No Fossil No Nuclear', taxonomyAlignedNoFossilNoNuclear.value], ['Other Investments', otherInvestments.value]];
      var filteredData = rawData.filter(function (row) {
        return row[1] !== null && row[1] !== 0;
      }); // Filter null data
      if (filteredData.length <= 1) {
        return [['Investment Type', 'Amount'], ['No Data', 1]];
      }
      return filteredData;
    });
    function investmentsAlignedWithEuTaxonomyChartOptions(title) {
      var options = {
        title: title,
        legend: true,
        colors: ['#809c7c', '#50744c', '#083404', '#e0dcdc']
      };
      return options;
    }
    var fossilAndNuclearAreLargerThanAligned = computed(function () {
      var _taxonomyAligned$valu4, _taxonomyAlignedFossi3, _taxonomyAlignedNucle3;
      var aligned = (_taxonomyAligned$valu4 = taxonomyAligned.value) !== null && _taxonomyAligned$valu4 !== void 0 ? _taxonomyAligned$valu4 : 0;
      var sum = ((_taxonomyAlignedFossi3 = taxonomyAlignedFossil.value) !== null && _taxonomyAlignedFossi3 !== void 0 ? _taxonomyAlignedFossi3 : 0) + ((_taxonomyAlignedNucle3 = taxonomyAlignedNuclear.value) !== null && _taxonomyAlignedNucle3 !== void 0 ? _taxonomyAlignedNucle3 : 0);
      return aligned > 0 && sum > aligned;
    });
    var alignedInvestmentsTreeview = computed(function () {
      var _calculatedSfdrReport2;
      return [{
        id: 'hasFossilOrNuclearActivities',
        name: 'Yes',
        disabled: !((_calculatedSfdrReport2 = calculatedSfdrReport.value) !== null && _calculatedSfdrReport2 !== void 0 && _calculatedSfdrReport2.hasAlignedEnvironmentalInvestments),
        selected: calculatedSfdrReport.value.hasFossilOrNuclearActivities,
        children: [{
          id: 'hasFossilActivities',
          name: 'In fossil gas',
          disabled: !calculatedSfdrReport.value.hasAlignedEnvironmentalInvestments,
          selected: calculatedSfdrReport.value.hasFossilActivities
        }, {
          id: 'hasNuclearActivites',
          name: 'In nuclear energy',
          disabled: !calculatedSfdrReport.value.hasAlignedEnvironmentalInvestments,
          selected: calculatedSfdrReport.value.hasNuclearActivities
        }]
      }, {
        id: 'hasNoFossilNorNuclearActivities',
        name: 'No',
        disabled: !calculatedSfdrReport.value.hasAlignedEnvironmentalInvestments,
        selected: calculatedSfdrReport.value.hasNoFossilNorNuclearActivities
      }];
    });
    return {
      __sfc: true,
      route: route,
      locale: locale,
      fundResult: fundResult,
      fund: fund,
      calculatedSfdrReportResult: calculatedSfdrReportResult,
      refetchFundReport: refetchFundReport,
      calculatedSfdrReport: calculatedSfdrReport,
      updateAssetAllocationTargets: updateAssetAllocationTargets,
      triggerUpdateAssetAllocationTargets: triggerUpdateAssetAllocationTargets,
      taxonomyAligned: taxonomyAligned,
      taxonomyAlignedFossil: taxonomyAlignedFossil,
      taxonomyAlignedNuclear: taxonomyAlignedNuclear,
      taxonomyAlignedNoFossilNoNuclear: taxonomyAlignedNoFossilNoNuclear,
      taxonomyAlignedEnabling: taxonomyAlignedEnabling,
      taxonomyAlignedTransitional: taxonomyAlignedTransitional,
      otherInvestments: otherInvestments,
      doesNotSumTo100: doesNotSumTo100,
      getPieChartData: getPieChartData,
      investmentsAlignedWithEuTaxonomyChartOptions: investmentsAlignedWithEuTaxonomyChartOptions,
      fossilAndNuclearAreLargerThanAligned: fossilAndNuclearAreLargerThanAligned,
      alignedInvestmentsTreeview: alignedInvestmentsTreeview,
      GChart: GChart,
      editablePrecontractualReportAdditionalInfo: editablePrecontractualReportAdditionalInfo,
      renderMarkdown: renderMarkdown
    };
  }
});